import React, { createContext } from 'react'
import { useParams } from 'react-router'
import { useSearchParams } from 'react-router'
import useRawState from '../hooks/useRawState'

const ClubContext = createContext()
export default ClubContext

export function RouteBasedClubProvider({ children }) {

    const { clubId } = useParams()

    return (
        <ClubProvider clubId={clubId}>
            {children}
        </ClubProvider>
    )
}

export function QueryBasedClubProvider({ children }) {
    const [searchParams] = useSearchParams()

    return (
        <ClubProvider clubId={searchParams.get('club')} children={children} />
    )
}


function ClubProvider({
    clubId,
    ...props
}) {
    const clubResult = useRawState(`/api/current/clubs/${clubId}`,{}, [clubId])

    return (
        <ClubContext.Provider
            value={clubResult}
            {...props}
        />
    )
}